import type { HTMLAttributes } from "react";
import { cn } from "../lib/cn";

/** A panel: `surface` with a `border` line and `radius-card`. Lines separate; shadows only lift what floats. */
export function Card({ className, ...props }: HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("rounded-(--radius-card) border border-border bg-surface p-6", className)}
      {...props}
    />
  );
}

export function CardTitle({ className, ...props }: HTMLAttributes<HTMLHeadingElement>) {
  return <h2 className={cn("text-heading font-semibold text-ink", className)} {...props} />;
}

export function CardDescription({ className, ...props }: HTMLAttributes<HTMLParagraphElement>) {
  return <p className={cn("text-small text-ink-muted", className)} {...props} />;
}
